const ONE_OF_OUR_SCRIPTS = /\/\/cdn(-integration)?\.malt\./;
// column number is optional, line number is captured
const ONE_OF_OUR_PAGES_WITH_LINE_NUMBER = /\/\/\w+\.malt\.\w+(?:\/.*?)?:(\d+)(?::\d+)?\)?$/;
const RELEVANT_LINE_NUMBER_FOR_INLINED_SCRIPTS = 500;

export function comesFromOurCode(errorStack) {
    if (ONE_OF_OUR_SCRIPTS.test(errorStack)) {
        return true;
    }

    const stackElements = errorStack.split(/\n(\s+at\s)?/).slice(1);

    const lineNumbersInOurPage = stackElements
        .map((loc) => ONE_OF_OUR_PAGES_WITH_LINE_NUMBER.exec(loc))
        .filter((match) => match)
        .map((match) => match[1]);

    return lineNumbersInOurPage.some((num) => num <= RELEVANT_LINE_NUMBER_FOR_INLINED_SCRIPTS);
}

export function mixin(Hop) {
    /* eslint no-console: 0 */
    Hop.logError = function (...args) {
        let message;
        if (arguments.length > 1) {
            const buf = [];
            for (let i = 0; i < arguments.length; i++) {
                const arg = args[i];
                if (typeof arg === 'object' && !arg.stack) {
                    buf.push(JSON.stringify(arg));
                } else {
                    buf.push(arg);
                }
            }
            message = buf.join(' ');
        } else {
            const errorOrMessage = args[0];
            if (typeof errorOrMessage === 'object' && !errorOrMessage.stack) {
                message = JSON.stringify(errorOrMessage);
                if (message === '{}' && errorOrMessage.status) {
                    message = `${errorOrMessage.url} ${errorOrMessage.status} ${errorOrMessage.statusText}`;
                }
            } else {
                message = errorOrMessage && errorOrMessage.toString();
            }
        }

        const event = {
            error: message,
            location: window.location.toString(),
        };

        // Log the error message and stack
        // Some browsers will display the message but not the stack, some others the other way around, etc.
        for (let i = 0; i < args.length; i++) {
            if (args[i].stack) {
                event.stack = args[i].stack;
                break;
            }
        }

        if (!event.stack) {
            event.stack = new Error('dummy error to have a stack').stack;
        }

        const stack = event.stack;
        delete event.stack;
        console.error(event, stack);
    };
}
